module.exports = "pegasus_template/assets/blocks/image-4-theme2.png";